var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"convention-push"},[_c('convention-push-header',{attrs:{"pushes":_vm.pushes,"convention":_vm.convention,"user":_vm.user}}),_c('div',{staticClass:"convention-push-list"},[_c('sep',{attrs:{"name":"L"}}),_vm._l((_vm.pushes),function(push){return _c('push-item',{key:push.id,attrs:{"push":push}})})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }